import "./App.css";
import "./styles/fontFaces.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GlobalStyle from './styles/globalStyles';
import Header from "./components/Header";
import Home from "./pages/Home";
import Snowzone from "./pages/Snowzone";
import { AppWrapper } from "./styles/styledComponents";
import { SelectedContextProvider } from "./context/selectedContext";
import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { useEffect } from "react";
import { piristeelTheme, plannjaTheme, ruukkiTheme } from "./styles/themes";

function App() {
  const [theme, setTheme] = useState<any>(null);

  useEffect(() => {
    console.log("🌍 ENVIRONMENT:", process.env.ENVIRONMENT);
    console.log("🔗 API_URL:", process.env.API_URL);
  }, []);
  
  const getLanguageIdFromChild = (value: any) => {
  
    if(value === undefined){setTheme(plannjaTheme)}
    else
    {
      const themeMode =
      value?.toUpperCase() === "SE" || value?.toUpperCase() === "NO"
        ? plannjaTheme
        : value?.toUpperCase() === "PIRISTEEL"
        ? piristeelTheme
        : ruukkiTheme;
 
      setTheme(themeMode);
    }
  };

  return (
    <ThemeProvider theme={theme || plannjaTheme}>
      <GlobalStyle />
      <AppWrapper>
        <SelectedContextProvider>
          <Router>
            <Header theme={theme} />
            <Routes>
            <Route
                path="/"
                element={<Home theme={theme} setParentLanguage={getLanguageIdFromChild} />}
              />
              <Route
                path="/:languageId"
                element={<Home theme={theme} setParentLanguage={getLanguageIdFromChild} />}
              />
                <Route
                path="/se/snolast-berakning"
                element={<Snowzone theme={theme} setParentLanguage={getLanguageIdFromChild} />}
              />
            </Routes>           
          </Router>
        </SelectedContextProvider>
      </AppWrapper>
    </ThemeProvider>
  );
}

export default App;
